import React, { MouseEventHandler, ReactNode } from 'react';
import styled from 'styled-components/macro';
import cx from 'classnames';

type Props = {
  className?: string;
  disabled?: boolean;
  onClick?: MouseEventHandler;
  count: number | string;
  btnClassName?: string;
  children?: ReactNode;
};

export const CountButton = (props: Props) => {
  const { className, disabled } = props;
  return (
    <div className={cx('man-ui count-btn', className)}>
      <button
        type="button"
        className={cx('btn', { disabled }, props.btnClassName)}
        onClick={props.onClick}
        disabled={props.disabled}
      >
        {props.children}
      </button>
      <Count className="count">{props.count}</Count>
    </div>
  );
};

const Count = styled.span`
  display: inline-block;
  padding: 5px 10px;
  font-size: 1rem;
  margin-left: 8px;
  position: relative;
  border-width: 1px;
  border-style: solid;
  border-radius: 2px;
  text-align: center;
  border-color: gray;
  vertical-align: middle;

  &:not(.disabled) {
    cursor: pointer;
  }

  ::after,
  ::before {
    right: 100%;
    top: 50%;
    border-style: solid;
    border-color: transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  ::before {
    border-width: 8px;
    margin-top: -8px;
    border-right-color: gray;
  }

  ::after {
    border-width: 6px;
    margin-top: -6px;
    border-right-color: white;
  }
`;
